import {
  Avatar,
  Button,
  Divider,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';

export interface IButtonSubject {
  icon: string;
  text: string;
  onClick: Function;
}

interface IButtons {
  leftBtn: IButtonSubject;
  rightBtn: IButtonSubject;
}

export const Buttons = ({ leftBtn, rightBtn }: IButtons) => {
  const btnStyle: SxProps = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    ':hover,:focus': {
      textDecoration: 'underline',
    },
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        mt: 'auto',
        bgcolor: 'primary.shade_100',
        borderRadius: '0 0 16px 16px',
        height: '56px',
      }}
    >
      <Button
        sx={{ ...btnStyle, gap: '6px', borderRadius: '0 0 0 16px' }}
        onClick={() => rightBtn.onClick()}
      >
        <Avatar
          alt=''
          src={rightBtn.icon}
          sx={{ width: '24px', height: '24px' }}
        />
        <Typography variant='body5'>{rightBtn.text}</Typography>
      </Button>
      <Divider
        orientation='vertical'
        sx={{ height: '24px', borderColor: 'primary.shade_200' }}
      />
      <Button
        sx={{ ...btnStyle, borderRadius: '0 0 16px 0' }}
        onClick={() => leftBtn.onClick()}
      >
        <Typography variant='body5'>{leftBtn.text}</Typography>
        <Avatar
          alt=''
          src={leftBtn.icon}
          sx={{ width: '20px', height: '20px' }}
        />
      </Button>
    </Stack>
  );
};
